import { useTranslation } from "react-i18next";
import React from "react";
import { Link, useLocation } from "react-router-dom";
function Banner() {
  const { t } = useTranslation();
  const location = useLocation();
  if (location.pathname === "/registration") return null;
  return (
    <div className="px-4 sm:px-6 lg:px-8 mt-4">
      <div className="flex items-center gap-x-6 bg-red-50 border border-red-100 px-6 py-3 rounded-xl justify-center transition-all duration-300 hover:bg-red-100/50 group">
        <p className="text-sm leading-6 text-red-800 text-center font-bold">
          <Link to="/registration" className="block w-full">
            <span className="underline decoration-2 underline-offset-4 group-hover:text-red-900 transition-colors">
              {t(
                "Seems like you haven't set up a merchant account yet. Please click here to proceed with building your account.",
              )}
            </span>
          </Link>
        </p>
      </div>
    </div>
  );
}
export default Banner;
